import React from 'react';
import { Container, Row, Col, Spinner, Alert } from 'react-bootstrap';
import PropTypes from 'prop-types';

import MemberCard from './MemberCard';

/**
 * MembersGrid Component
 * Displays a grid of community members
 */
const MembersGrid = ({
    members = [],
    loading = false,
    error = null,
    onBan = null,
    onUnban = null,
    isSiteAdmin = false,
    isModeratorOfCommunity = false,
    currentUserId = '',
}) => {
    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center py-5">
                <Spinner animation="border" variant="primary">
                    <span className="visually-hidden">Loading members...</span>
                </Spinner>
            </div>
        );
    }

    if (error) {
        return (
            <Alert variant="danger" className="my-4">
                {error}
            </Alert>
        );
    }

    if (!members || members.length === 0) {
        return (
            <div className="text-center py-5 text-muted">
                <i
                    className="bi bi-people fs-1 d-block mb-3"
                    aria-hidden="true"
                />
                <p>No members yet. Be the first to join!</p>
            </div>
        );
    }

    return (
        <Container>
            <Row xs={1} sm={2} md={3} lg={4} className="g-4 py-4">
                {members
                    .filter(
                        (m) =>
                            m.status === 'active' ||
                            isSiteAdmin ||
                            isModeratorOfCommunity
                    )
                    .map((member) => (
                        <Col key={member._id}>
                            <MemberCard
                                userId={member.user?._id}
                                username={member.user?.username}
                                profilePicture={member.user?.profilePicture}
                                bio={member.user?.bio}
                                organization={member.user?.organization}
                                userType={member.user?.userType}
                                role={member.role}
                                status={member.status}
                                joinedAt={member.joinedAt}
                                membership={member}
                                isSiteAdmin={isSiteAdmin}
                                isModeratorOfCommunity={isModeratorOfCommunity}
                                onBan={onBan}
                                onUnban={onUnban}
                                currentUserId={currentUserId}
                            />
                        </Col>
                    ))}
            </Row>
        </Container>
    );
};

MembersGrid.propTypes = {
    members: PropTypes.arrayOf(
        PropTypes.shape({
            _id: PropTypes.string.isRequired,
            role: PropTypes.string,
            status: PropTypes.string,
            joinedAt: PropTypes.string,
            user: PropTypes.shape({
                _id: PropTypes.string,
                username: PropTypes.string,
                profilePicture: PropTypes.string,
                bio: PropTypes.string,
                organization: PropTypes.string,
                userType: PropTypes.string,
            }),
        })
    ),
    loading: PropTypes.bool,
    error: PropTypes.string,
    onBan: PropTypes.func,
    onUnban: PropTypes.func,
    isSiteAdmin: PropTypes.bool,
    isModeratorOfCommunity: PropTypes.bool,
    currentUserId: PropTypes.string,
};

export default MembersGrid;
